module.exports = __webpack_public_path__ + "static/media/header-bg-2-rough.29a85aed.png";